import React, { ReactNode } from "react";
import { mergeClasses } from "../utils/styles.util";

interface ButtonProps {
  children: ReactNode;
  Icon?: ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
}

const Button: React.FC<ButtonProps> = ({ children, Icon, disabled, onClick, className }) => {
  return (
    <div className={mergeClasses("flex items-center gap-2 border border-gray-500 rounded-md px-2 py-1", disabled ? "pointer-events-none" : "cursor-pointer", className)} onClick={onClick}>
      {Icon && <div className="flex items-center">{Icon}</div>}
      {children}
    </div>
  );
};

export default Button;
